.atm_vy_1osqo2v{width:100%;}
.atm_e2_1osqo2v{height:100%;}
.atm_9s_1ulexfb{display:block;}
.atm_gi_idpfg4{margin:0;}
.atm_l8_idpfg4{padding:0;}
.atm_mk_stnw88{position:absolute;}
.atm_tk_idpfg4{top:0;}
.atm_fq_idpfg4{left:0;}
.atm_k4_idpfg4{opacity:0;}
.atm_wq_kb7nvz{z-index:1;}
.atm_9j_tlke0l{cursor:pointer;}
.atm_9j_13gfvf7{cursor:not-allowed;}
